import { useState, useEffect } from "react";

// Renders an ad creative with a safe fallback so a broken/missing image never
// breaks the layout on landing pages or live scoreboards.
export default function AdImage({ src, alt, className = "", style = {}, testid }) {
  const [err, setErr] = useState(false);
  useEffect(() => setErr(false), [src]);

  if (!src || err) {
    return (
      <div
        data-testid={testid || "ad-placeholder"}
        className={`flex items-center justify-center glass ${className}`}
        style={style}
      >
        <span className="text-xs mono" style={{ color: "var(--text-2)" }}>[Banner Preview Asset]</span>
      </div>
    );
  }
  return (
    <img
      data-testid={testid}
      src={src}
      alt={alt || ""}
      className={className}
      style={style}
      onError={() => setErr(true)}
    />
  );
}
